module.exports = __webpack_public_path__ + "static/media/wallet.f9349ca9.svg";